import apiClient from "../common/apiClient.js";

export default class ContentManageController {
  async CreateContent(data, token) {
    try {
      return await apiClient.post("/mediaManage", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }
  async UpdateContent(data, token) {
    try {
      return await apiClient.put("/content", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }
  async GetContent(id, token) {
    try {
      return await apiClient.get("/content" + id, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }

  async CreateMedia(data, token) {
    try {
      return await apiClient.post("/media", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }
  async getMemberMasters() {
    try {
      return await apiClient.get("/masters/getMembers");
    } catch (error) {
      return error;
    }
  }
}
